import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { downArrowChevronIcon } from "../../resources/images";

interface TableColumn {
  label: string;
  align?: "left" | "right";
  key: string;
  showArrow?: boolean;
}

interface TableRowData {
  [key: string]: string | number;
}

interface TableSumAssuredData {
  label?: string;
  value: string;
}

interface MetricsDisplayTableProps {
  tableHeadersData: TableColumn[];
  tableRowsData: TableRowData[];
  tableSumAssuredData: TableSumAssuredData[];
}

const MetricsDisplayTable: React.FC<MetricsDisplayTableProps> = (props) => {
  // PROPS
  const { tableHeadersData, tableRowsData, tableSumAssuredData } = props;

  return (
    <Box sx={{ padding: 2 }}>
      <TableContainer
        component={Paper}
        // TODO: LATER WE CAN ADD THIS STYLES
        sx={{
          borderRadius: "12px",
          padding: "0px 20px 23px 20px",
        }}
      >
        {/* <Box sx={{ width: "107px", height: "21px", marginBottom: "14px" }}>
          <img
            src={metaLogo}
            alt="metaLogo"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box> */}
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow>
              {tableHeadersData.map((column, index) => (
                <TableCell
                  key={index}
                  align={column.align}
                  sx={{
                    border: "none",
                    padding: "8px",
                    fontFamily: "Scoop",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "21px",
                    textAlign: "left",
                    color: "rgba(0, 0, 0, 1)",
                    cursor: "pointer",
                  }}
                >
                  {column.label}
                  {column.showArrow && (
                    <img
                      src={downArrowChevronIcon}
                      alt="Arrow"
                      style={{
                        width: "12px",
                        height: "12px",
                        marginLeft: "4px",
                      }}
                    />
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRowsData?.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor:
                    index % 2 === 0 ? "rgba(245, 245,245)" : "#ffffff",
                }}
              >
                {tableHeadersData.map((column, idx) => (
                  <TableCell
                    key={idx}
                    align={column.align}
                    sx={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Scoop",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "31px",
                      color: "rgba(0, 0, 0, 1)",
                    }}
                  >
                    {row[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            <TableRow
              sx={{
                backgroundColor: "rgba(237, 246, 253)",
              }}
            >
              {tableSumAssuredData?.map((sumAssured, index) => {
                return (
                  <TableCell
                    key={index}
                    sx={{ border: "none", fontWeight: "700", padding: "8px" }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Scoop",
                        fontSize: "14px",
                        fontWeight: "700",
                        lineHeight: "31px",
                        textAlign: "left",
                      }}
                    >
                      {sumAssured?.value}
                    </Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export { MetricsDisplayTable };
